import React from 'react'
import {
	Col, Layout, Row
}from 'antd'

import 'antd/lib/layout/style/css'
import 'antd/lib/row/style/css'
import 'antd/lib/col/style/css'

import './index.css'

import gerb from './gerb.png'
import rntc from './rntc.png'
import bsc from './bsc.png'
import stn from './stn.png'
import budexport from './budexport.png'

const Footer = () => {
	return (
		<Layout.Footer className="layout-footer">
			<Row
				align="middle"
				className="layout-footer-row"
			>
				<Col
					lg={ 12 }
					md={ 12 }
					sm={ 24 }
					xl={ 8 }
					xs={ 24 }
					xxl={ 5 }
				>
					<a
						href="http://mas.gov.by/ru"
						rel="noopener noreferrer"
						target="_blank"
					>
						<Row
							className="layout-footer-left-block"
							type="flex"
						>
							<img
								alt="Герб"
								className="layout-footer-logo"
								src={ gerb }
							/>
							<h4>
                                Министерство архитектуры
								<br />
и строительства
								{ ' ' }
								<br />
								{ ' ' }
Республики Беларусь
							</h4>
						</Row>
					</a>
				</Col>
				<Col
					lg={ 12 }
					md={ 12 }
					sm={ 24 }
					xl={ 8 }
					xs={ 24 }
					xxl={ 5 }
				>
					<a
						href="http://www.rstc.by"
						rel="noopener noreferrer"
						target="_blank"
					>
						<Row
							className="layout-footer-left-block"
							type="flex"
						>
							<img
								alt="РНТЦ"
								className="layout-footer-logo"
								src={ rntc }
							/>
							<h4>
								РУП "Республиканский
								<br />
научно-технический центр
								<br />
								{ ' ' }
по ценообразованию
								<br />
в строительстве"
							</h4>
						</Row>
					</a>
				</Col>
				<Col
					lg={ 12 }
					md={ 12 }
					sm={ 24 }
					xl={ 8 }
					xs={ 24 }
					xxl={ 4 }
				>
					<a
						href="https://bsc.by/ru"
						rel="noopener noreferrer"
						target="_blank"
					>
						<Row
							className="layout-footer-left-block"
							type="flex"
						>
							<img
								alt="БСЦ"
								className="layout-footer-logo"
								src={ bsc }
							/>
							<h4>
								РУП "Белстройцентр"
							</h4>
						</Row>
					</a>
				</Col>
				<Col
					lg={ 12 }
					md={ 12 }
					sm={ 24 }
					xl={ 8 }
					xs={ 24 }
					xxl={ 4 }
				>
					<a
						href="https://stn.by/"
						rel="noopener noreferrer"
						target="_blank"
					>
						<Row
							className="layout-footer-left-block"
							type="flex"
						>
							<img
								alt="СТН"
								className="layout-footer-logo"
								src={ stn }
							/>
							<h4>
								РУП "СТРОЙТЕХНОРМ"
							</h4>
						</Row>
					</a>
				</Col>
				<Col
					lg={ 12 }
					md={ 12 }
					sm={ 24 }
					xl={ 8 }
					xs={ 24 }
					xxl={ 6 }
				>
					<a
						href="https://budexport.by/"
						rel="noopener noreferrer"
						target="_blank"
					>
						<Row
							className="layout-footer-left-block"
							type="flex"
						>
							<img
								alt="BUDEXPORT"
								className="layout-footer-logo"
								src={ budexport }
							/>
							<h4>
									BUDEXPORT
								<br />
								{ ' ' }
Информационно-аналитическая
								<br />
								{ ' ' }
система поддержки
								{ ' ' }
								<br />
экспорта строительных услуг
							</h4>
						</Row>
					</a>
				</Col>
			</Row>
			<Row
				align="middle"
				className="layout-footer-bottom-row-link"
				justify="center"
			>
				<h4>
© Государственная информационная система "Госстройпортал". Министерство архитектуры и строительства
                    Республики Беларусь, 2020

				</h4>
			</Row>
		</Layout.Footer>
	)
}

export default Footer